<!-- NAVBAR -->
<app-navbar-panel
  class="fixed inset-x-0 top-0 h-[var(--navbar-height,64px)] z-50">
</app-navbar-panel>

<!-- SIDEBAR -->
<app-sidebar
  (menuStatus)="setStatusMenu($event)"
  class="fixed left-0 top-[var(--navbar-height,64px)]
         h-[calc(100vh-var(--navbar-height,64px))] z-40
         w-[var(--sidebar-width,90px)]
         transition-[width] duration-300 ease-in-out">
</app-sidebar>

<!-- CONTEÚDO -->
<div
  class="min-h-screen
         pt-[var(--navbar-height,64px)]
         pl-[var(--sidebar-width,90px)]
         transition-[padding] duration-300 ease-in-out">

  <section class="px-4 md:px-8">
    <router-outlet></router-outlet>
  </section>
</div>
